import { Image } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

export interface User {
  name: string;
  skymilesNumber: string;
  validity: GenericLabel;
}

export interface MembershipCard {
  image: Image;
  user: User;
  barcode: Image;
  info: string;
  rules: string;
}
